export default __webpack_public_path__ + "static/media/stufflayout-headphone.678474a8.png";